export const blogUrl = 'https://blog.veroo.com.br';
export const businessUrl = 'https://b2b.veroo.com.br';
export const supportUrl = 'https://veroo.cafe/contato';
export const instagramUrl = 'https://instagram.com/veroocafes';
